var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.127.873C14.565.31 13.817 0 13.021 0H2.979C1.336 0 0 1.337 0 2.98v10.04C0 14.665 1.337 16 2.98 16h10.04c1.644 0 2.98-1.336 2.98-2.98V2.98c0-.797-.31-1.545-.873-2.107zm-.065 12.148c0 1.126-.915 2.041-2.041 2.041H2.979c-1.126 0-2.042-.915-2.042-2.041V2.979c0-1.126.916-2.042 2.042-2.042h10.042c.545 0 1.058.213 1.444.599.385.385.598.898.598 1.443v10.042z",
    transform: "translate(-1280 -102) translate(1264 94) translate(16 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.746 6.968c-.178-.182-.468-.182-.646 0L8.457 8.646v-4.98c0-.257-.205-.466-.457-.466s-.457.209-.457.467v4.98L5.9 6.967c-.178-.182-.468-.182-.646 0-.179.183-.179.478 0 .66l2.423 2.475c.086.088.202.137.323.137s.237-.05.323-.137l2.423-2.475c.179-.182.179-.477 0-.66zM12.959 12.16H3.68c-.266 0-.481.143-.481.32 0 .177.215.32.481.32h9.278c.266 0 .481-.143.481-.32 0-.177-.215-.32-.481-.32z",
    transform: "translate(-1280 -102) translate(1264 94) translate(16 8)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/exportIcon.05138889ff6891e03df1ded7d405f4e3.svg";
export { ForwardRef as ReactComponent };